import { Avatar, Stack } from "@mui/material";
import {
  Star,
  MilitaryTech as SOTAIcon,
  TrendingUp as TrendingIcon
} from "@mui/icons-material";

import ToolTip from "../Tooltip";
import { RecommendedIcon } from "../Icon/Similar";

export default function GameBadge({
  scoreTrending,
  models,
  scoreSota,
  scoreSimilarity
}) {
  scoreSota ??= models?.[0]?.scoreSota;

  if (
    Number.isFinite(scoreSota) ||
    Number.isFinite(scoreTrending) ||
    Number.isFinite(scoreSimilarity)
  ) {
    const score = scoreSota || scoreTrending || scoreSimilarity;
    const variant = scoreSota
      ? "sota"
      : scoreTrending
      ? "trending"
      : "recommended";
    const stars = Math.ceil(3 * score);

    return (
      <ToolTip
        title={`${["Somewhat", "Is", "Strongly", "Most"][stars]} ${
          scoreSota ? "State-of-art" : scoreTrending ? "Trending" : "Similar"
        }`}
      >
        <Badge variant={variant} stars={stars} />
      </ToolTip>
    );
  }
}

export const Badge = ({ variant, stars = 0 }) => {
  const Icon =
    {
      sota: SOTAIcon,
      trending: TrendingIcon,
      recommended: RecommendedIcon
    }[variant] || (() => null);

  return (
    <Avatar
      variant="rounded"
      sx={{
        display: "flex",
        flexDirection: "column",
        bgcolor: "surface.container.high"
      }}
    >
      <Icon sx={{ color: theme => theme.palette.colors.success[50] }} />
      <Stack direction="row">
        {new Array(stars).fill().map((_, index) => (
          <Star
            key={index}
            sx={{ color: "warning.main", height: 10, width: 10 }}
          />
        ))}
      </Stack>
    </Avatar>
  );
};
